import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { visibilityIcon } from '@/constants/images';
import { readStates, saveStates, states } from '@/constants/lifecycle';
import MessageRow from '@/components/table/MessageRow';
import { entityCommonsVisibility, entityVisibility } from '@/constants/states';
import VisibilityDropdown from '@/components/VisibilityDropdown';
import DatasetActionsDropdown from './DatasetActionsDropdown';
import CatalogueTemplatesDropdown from '../../catalogue/templates/components/CatalogueTemplatesDropdown';
import { datasetSettingsFields } from '../state/state';
import { datasetManagePermissions } from '../../sharing/constants';
import { showCatalogueConfirmation, updateDatasetSettings } from '../actions';
import DatasetDataModelDropdown from '../../datamodels/components/DatasetDataModelDropdown';

const DatasetBasicSettingRows = ({
  allowDataModelRead,
  canChangeSettings,
  canChangeVisibility,
  category,
  code,
  commonsMode,
  confirmCatalogue,
  hideCatalogue,
  name,
  template,
  updateSettings,
  visibility,
}) => (
  <>
    <MessageRow
      collapsing
      context="dataset.setting"
      icons={[visibilityIcon[visibility]]}
      message="dataset.settings.visibility.field.label"
      entity="manage"
    >
      <VisibilityDropdown
        className="min-w-230"
        commonsMode={commonsMode}
        disabled={!canChangeVisibility}
        onChange={(properties) => updateSettings(category, code, { visibility: properties.visibility }, name)}
        size="mini"
        visibility={visibility}
        {...commonsMode && { visibilityOptions: Object.values(entityCommonsVisibility) }}
      />
    </MessageRow>
    {!hideCatalogue && (
      <MessageRow
        collapsing
        context="dataset.setting"
        icons={['book']}
        message="dataset.settings.catalogue.template.field.label"
        entity="manage"
      >
        <CatalogueTemplatesDropdown
          category="lookups"
          direction="left"
          template={template}
          onChange={(t) => confirmCatalogue(code, category, t, name)}
          disabled={!canChangeSettings}
        />
      </MessageRow>
    )}
    <MessageRow
      collapsing
      context="dataset.setting"
      icons={['linkify']}
      message="dataset.settings.custom.actions.field.label"
      entity="manage"
    >
      <DatasetActionsDropdown category={category} code={code} name={name} />
    </MessageRow>
    { allowDataModelRead && (
      <MessageRow
        context="dataset.setting"
        icons={['tag']}
        message="dataset.settings.datamodel.dropdown.label"
        entity="manage"
      >
        <DatasetDataModelDropdown category={category} code={code} name={name} />
      </MessageRow>
    )}
  </>
);

export const mapStateToProps = ({
  datasetSettings: { settings },
  auth: { commonsMode, role: { permissions: { datamodels: { read } } } },
  datasetUsers: { permissions },
}, { category, code }) => {
  const perms = findResult(permissions, category, code) || { ...readStates };
  const item = findResult(settings, category, code)
        || {
          ...datasetSettingsFields(),
          ...saveStates,
          visibility: entityVisibility.PRIVATE,
          catalogue_definition_code: '',
        };

  return ({
    allowDataModelRead: read,
    canChangeSettings: item.saveStatus !== states.PENDING && perms[datasetManagePermissions.SETTINGS],
    canChangeVisibility: perms[datasetManagePermissions.VISIBILITY],
    commonsMode,
    template: item.catalogue_definition_code,
    visibility: item.visibility,
  });
};

export const mapDispatchToProps = {
  confirmCatalogue: showCatalogueConfirmation,
  updateSettings: updateDatasetSettings,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetBasicSettingRows);
